import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Logs a Firebase Analytics page_view on every route change. Mounted once
 * inside the Router. Renders nothing.
 */
export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // pathname only — intentionally excludes the query string so we never
    // log the Stripe session_id / payment params.
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
